import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import Button from "../UI/Button";
import {
  consultaCantinaCreditoSolicitacaoTransacaoPix,
  criarCantinaCreditoSolicitacaoTransacaoPix,
} from "./CantinaCreditoSolicitacao/api-cantina-credito-solicitacao";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { toast } from "react-toastify";
import PixImg from "../../shared/assets/img/financeiro/pix.png";

const InsereCreditoPixForm = () => {
  const trintaKey = "trinta";
  const [checkBoxValorSelecionado, setCheckBoxValorSelecionaro] =
    useState(trintaKey);
  const quarentaKey = "quarenta";
  const sessentaKey = "sessenta";
  const descritoValorKey = "descrito-valor";
  const [cantinaCreditoSolicitacao, setCantinaCreditoSolicitacao] = useState({
    valorCredito: 30,
  });
  const [isLoadingAction, setIsLoadingAction] = useState(false);

  const handleOnSubmit = (event) => {
    event.preventDefault();
    setIsLoadingAction(true);
    criarCantinaCreditoSolicitacaoTransacaoPix(cantinaCreditoSolicitacao).then(
      (data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setCantinaCreditoSolicitacao(data);
          }
        }
        setIsLoadingAction(false);
      }
    );
  };

  const handleChangeCheckBoxValorCredito = (event) => {
    const nameTarget = event.target.name;
    if (nameTarget === trintaKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 30,
      }));
    } else if (nameTarget === quarentaKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 40,
      }));
    } else if (nameTarget === sessentaKey) {
      setCantinaCreditoSolicitacao((prevState) => ({
        ...prevState,
        valorCredito: 60,
      }));
    }
    setCheckBoxValorSelecionaro(nameTarget);
  };

  const handleChangeTextFieldValorCredito = (event) => {
    setCantinaCreditoSolicitacao({
      ...cantinaCreditoSolicitacao,
      valorCredito: event.target.value,
    });
  };

  const handleCopyCodeToClipboard = () => {
    navigator.clipboard
      .writeText(cantinaCreditoSolicitacao.pixTransacao.qrCodeTexto)
      .then(() => {
        console.log("Text successfully copied to clipboard!");
        toast.success("Código Pix Copiado.", {
          position: "bottom-left",
        });
        // Optional: Provide user feedback, e.g., an alert or a temporary message
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        // Optional: Handle the error gracefully, e.g., display an error message
      });
  };

  const handleVerificarPagamento = () => {
    setIsLoadingAction(true);
    consultaCantinaCreditoSolicitacaoTransacaoPix(
      cantinaCreditoSolicitacao.codigo
    ).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCantinaCreditoSolicitacao(data);
        }
      }
      setIsLoadingAction(false);
    });
  };

  return (
    <Container sx={{ paddingTop: 2, paddingBottom: 2 }} component={Paper}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <Typography variant="h6">Pix</Typography>
        </Grid>
        <Grid size={12}>
          <Typography variant="body1">
            Selecione ou Digite o valor para o Crédito:
          </Typography>
        </Grid>
        <Grid size={12}>
          <form onSubmit={handleOnSubmit}>
            <Grid container spacing={1}>
              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkBoxValorSelecionado === trintaKey}
                      onChange={handleChangeCheckBoxValorCredito}
                      name={trintaKey}
                    />
                  }
                  label="R$ 30,00"
                />
              </Grid>
              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkBoxValorSelecionado === quarentaKey}
                      onChange={handleChangeCheckBoxValorCredito}
                      name={quarentaKey}
                    />
                  }
                  label="R$ 40,00"
                />
              </Grid>
              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkBoxValorSelecionado === sessentaKey}
                      onChange={handleChangeCheckBoxValorCredito}
                      name={sessentaKey}
                    />
                  }
                  label="R$ 60,00"
                />
              </Grid>
              <Grid size={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkBoxValorSelecionado === descritoValorKey}
                      onChange={handleChangeCheckBoxValorCredito}
                      name={descritoValorKey}
                    />
                  }
                  label="Digite o Valor do Crédito"
                />
              </Grid>
              {checkBoxValorSelecionado === descritoValorKey && (
                <Grid size={12}>
                  <Grid
                    container
                    direction="row"
                    spacing={3}
                    alignItems="center"
                  >
                    <Grid size={3}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        type="number"
                        label="Valor Crédito"
                        name="valorCredito"
                        onChange={handleChangeTextFieldValorCredito}
                        // value={cantinaCreditoSolicitacao && cantinaCreditoSolicitacao.valorCredito ? currencyRound(cantinaCreditoSolicitacao.valorCredito) : "0.00"}
                        value={
                          cantinaCreditoSolicitacao &&
                          cantinaCreditoSolicitacao.valorCredito
                            ? cantinaCreditoSolicitacao.valorCredito
                            : ""
                        }
                      />
                    </Grid>
                    <Grid size={3}>
                      <Typography variant="body1">
                        Serão aceitos valores entre R$ 30,00 e R$ 500,00.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Grid size={12}>
                <Grid container direction="row" spacing={3}>
                  <Grid>
                    <Button
                      type="submit"
                      disabled={isLoadingAction}
                      isLoadingAction={isLoadingAction}
                    >
                      Gerar Pix
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      disabled={isLoadingAction}
                      isLoadingAction={isLoadingAction}
                      onClick={handleVerificarPagamento}
                    >
                      Verificar Pagamento
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              {cantinaCreditoSolicitacao &&
                cantinaCreditoSolicitacao.pixTransacao && (
                  <>
                    <Grid size={12}>
                      <Grid
                        container
                        direction="row"
                        spacing={3}
                        alignItems="center"
                      >
                        <Grid>
                          <img
                            src={PixImg}
                            style={{ height: "60px", width: "50px" }}
                            alt=""
                          />
                        </Grid>
                        <Grid>
                          <Typography variant="h6">Pix Copia e Cola</Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid size={12}>
                      <Typography>
                        {cantinaCreditoSolicitacao.pixTransacao &&
                        cantinaCreditoSolicitacao.pixTransacao.qrCodeTexto
                          ? cantinaCreditoSolicitacao.pixTransacao.qrCodeTexto
                          : ""}
                      </Typography>
                    </Grid>
                    <Grid size={12}>
                      <Button onClick={handleCopyCodeToClipboard}>
                        Copiar Código Pix
                      </Button>
                    </Grid>
                    <Grid size={12}>
                      <img
                        alt=""
                        style={{
                          height: "200px",
                          width: "200px",
                        }}
                        src={
                          cantinaCreditoSolicitacao.pixTransacao &&
                          cantinaCreditoSolicitacao.pixTransacao.qrCodeImagem
                            ? cantinaCreditoSolicitacao.pixTransacao
                                .qrCodeImagem
                            : null
                        }
                      />
                    </Grid>
                  </>
                )}
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default InsereCreditoPixForm;
